import Button from '@atoms/Button/Button';
import Search from '@atoms/Search/Search';
import SiteEnum from '@models/enums/SiteEnum';
import { QueryState } from '@models/IListingWrapper';
import {
  useListingDispatch,
  useListingState,
} from '@utility/context/ListingContext';
import { ActionType } from '@utility/reducers/ListingWrapper';
import { useRef } from 'react';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';

interface Props {
  readonly autoCompleteEndpoint?: string;
  readonly autoCompletePlaceholder?: string;
  readonly disabled: boolean;
  readonly errors?: any;
  readonly initialSearchText?: string;
  readonly openLabel: string;
  readonly register: UseFormRegister<QueryState>;
  readonly showSearchInListing?: boolean;
  readonly site: SiteEnum;
  readonly handleFormSubmit: () => void;
  readonly onAutoCompleteSubmit: (value: string) => void;
  readonly setValue: UseFormSetValue<QueryState>;
}

const ListingFilters = ({
  autoCompleteEndpoint,
  autoCompletePlaceholder,
  disabled,
  errors,
  initialSearchText,
  openLabel,
  register,
  showSearchInListing,
  site,
  handleFormSubmit,
  onAutoCompleteSubmit,
  setValue,
}: Props) => {
  const { isMobileFiltersOpen, clearSearch } = useListingState();
  const dispatch = useListingDispatch();
  const filtersRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="tw-flex tw-gap-4 ">
      <div className="tw-hidden tw-gap-sm lg:tw-flex">
        <Button
          aria-label={openLabel}
          aria-controls="filters-modal"
          aria-expanded={isMobileFiltersOpen}
          disabled={disabled}
          variant={site === SiteEnum.B2B ? 'yellow' : 'white'}
          label={openLabel}
          iconName="filter"
          buttonClasses="tw-w-full lg:tw-w-auto [&>div]:tw-justify-between tw-border tw-border-grey-10 hover:tw-border-black tw-flex"
          contentClasses="tw-text-base"
          onClick={() =>
            dispatch({ type: ActionType.MOBILE_FILTERS_OPEN, payload: true })
          }
          ref={filtersRef}
        />
        {showSearchInListing && autoCompleteEndpoint && (
          <form onSubmit={handleFormSubmit}>
            <Search
              clearSearch={clearSearch}
              autoCompleteEndpoint={autoCompleteEndpoint}
              setValue={setValue as any}
              errors={errors}
              label={'Search'}
              name={'freetext'}
              initialValue={initialSearchText ?? ''}
              register={register as any}
              placeholder={autoCompletePlaceholder}
              onAutoCompleteSelect={onAutoCompleteSubmit}
              searchClasses="!tw-border-grey-10 [&_svg]:tw-fill-black tw-min-w-[302px] !tw-text-base"
            />
          </form>
        )}
      </div>
    </div>
  );
};

export default ListingFilters;
